import {Component, Inject, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Audit} from "../../_models/audit";
import {AuditService} from "../../_services/audit.service";

@Component({
    standalone: false,
  selector: "select-audit-template",
  templateUrl: 'select-audit-template.component.html',
  styleUrls: ['./select-audit-template.component.scss'],
})
export class SelectAuditTemplateComponent implements OnInit {
  templates: Audit[] = [];
  templateId: number = 0;

  constructor(
    public auditService: AuditService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public router: Router,
    public dialogRef: MatDialogRef<SelectAuditTemplateComponent>) {
  }

  ngOnInit() {
    this.auditService.getAuditTemplates().subscribe(i => {
      this.templates = i;
    });
  }
  create() {
    this.dialogRef.close(this.templateId);
  }
}
